import { custom } from "./actionsUtilities";
import { EMPTY_STRING, systemConstants } from "../../constants";

//-------activate spinner
const activateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.SPINNER_ACTIVATE));
  };
};

//-------Deactivate Spinner
const deactivateSpinner = (data) => {
  return (dispatch) => {
    dispatch(custom(data, systemConstants.SPINNER_DEACTIVATE));
  };
};

const activateDraggableNotification = (message = "Processing...") => {
  return (dispatch) => {
    dispatch(custom(message, systemConstants.DRAGGABLE_NOTIFICATION_ACTIVATE));
  };
};

const deactivateDraggableNotification = (message = EMPTY_STRING) => {
  return (dispatch) => {
    dispatch(
      custom(message, systemConstants.DRAGGABLE_NOTIFICATION_DEACTIVATE)
    );
  };
};

//-------Page Redireaction
const pageRedireaction = (path) => {
  return (dispatch) => {
    dispatch(custom(path, systemConstants.TOGGLE_REDIRECT_PAGE));
  };
};

export const systemActions = {
  activateSpinner,
  deactivateSpinner,
  pageRedireaction,
  activateDraggableNotification,
  deactivateDraggableNotification,
};
